import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import { Box, Link, Typography } from '@mui/material'
import { color } from 'config/color'
import { useNavigate } from 'react-router-dom'

interface ServiceFooterProps {
    title: string
    desc: string
    link: string
    linkTitle: string
    icon: any
}

export const ServiceFooterButton: React.FC<ServiceFooterProps> = (props: ServiceFooterProps) => {
    const navigate = useNavigate()

    const isExternalLink = props.link.startsWith('http') || props.link.startsWith('https')

    return <Box flex={1} p={2} bgcolor={color.background[50]} borderRadius={1}>
        <props.icon sx={{ color: color.primary[600] }} aria-hidden="true" />
        <Typography color={color.grey[900]} fontSize="18px" variant="h3">
            {props.title}
        </Typography>
        <Typography color={color.grey[700]} fontSize="14px">
            {props.desc}
        </Typography>
        {isExternalLink
            ? (
                <a
                    href={props.link}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ textDecoration: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                    aria-label={props.linkTitle}
                >
                    <Typography component="span" color={color.primary[800]} fontSize={12} >
                        {props.linkTitle}
                    </Typography>
                    <ArrowRightAltIcon sx={{ color: color.primary[800] }} aria-hidden="true" />
                </a>
            )
            : (
                <Link
                    sx={{ textDecoration: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                    onClick={() => { navigate(props.link) }}
                    aria-label={props.linkTitle}
                    tabIndex={0}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            navigate(props.link)
                        }
                    }}
                >
                    <Typography component="span" color={color.primary[800]} fontSize={12} >
                        {props.linkTitle}
                    </Typography>
                    <ArrowRightAltIcon sx={{ color: color.primary[800] }} aria-hidden="true" />
                </Link>
            )}

    </Box >
}
